module.exports = __webpack_public_path__ + "static/media/logo.bf8e685f.svg";